<template>
  <div class="main-layout main-layout_fullpage">
    <div
      class="main-layout__head main-layout__head_pb24 main-layout__head_flex main-layout__head_pr40"
    >
      <h2 class="main-title">{{ $t("navigation.clients") }}</h2>

      <div class="flex">
        <Select2
          v-if="filteredList"
          :options="filteredList"
          :settings="{
            placeholder: 'Niederlassung',
            allowClear: false,
          }"
          v-model="params.office_id"
          class="select mr-12"
          @select="filter"
        />

        <search @searchData="searchClient" :value="search" />
      </div>
    </div>

    <clients-list v-if="usersData && isLoad" />

    <add-btn @onClick="toggleShowModalAdd" />

    <modal :show="showModalAdd" :dark="true" :outside="false" @close="toggleShowRequestModalAdd">
      <transition name="showmodal">
        <request-add-modal @close="toggleShowRequestModalAdd" />
      </transition>
    </modal>
  </div>
</template>

<script>
import requestAddModal from '@/components/modals/requests/requestAddModal'
import addBtn from '@/components/controls/addBtn'

import { mapMutations, mapActions, mapGetters } from 'vuex'
import store from '../store'

export default {
    components: {
        requestAddModal,
        addBtn,
    },
    data() {
        return {
            isActive: 'list',
            newCompanyTitle: this.$t('pages.newCompany'),
            request: '',
            isLoad: false,
            // params: {
            //   office_id: null,
            // },
        }
    },
    computed: {
        ...mapGetters({
            showModalAdd: 'requests/showModalAdd',
            filteredList: 'offices/filteredListAll',
            params: 'clientParams',
        }),
        search: {
            get() {
                return this.$store.state.clients.search
            },
            set(data) {
                this.$store.state.clients.search = data
                store.dispatch('getClientsData', { word: data, params: this.params })
            },
        },
        employeeData() {
            return this.$store.state.companies.employeeData
        },
        usersData() {
            return this.$store.state.clients.data
        },
    },
    methods: {
        ...mapMutations({
            setClientModal: 'setClientModal',
            setCLient: 'setCLient',
            setClientModalType: 'setClientModalType',
            toggleShowRequestModalAdd: 'requests/toggleShowModalAdd',
            clearClientParams: 'clearClientParams',
        }),
        ...mapActions({
            addApplication: 'addApplication',
        }),
        changeView(view) {
            this.isActive = view
        },
        deleteClient(id) {
            this.$Progress.start()
            store
                .dispatch('deleteClient', id)
                .then(() => {
                    this.$Progress.finish()
                })
                .catch(() => {
                    this.$Progress.finish()
                })
        },
        searchClient(data) {
            this.search = data
        },
        getClientData(clientId) {
            this.$Progress.start()
            store
                .dispatch('getClientData', clientId)
                .then(() => {
                    this.$Progress.finish()
                })
                .catch(() => {
                    this.$Progress.finish()
                })
        },
        addCompany(employeeId) {
            this.$Progress.start()
            store
                .dispatch('addCompany', { transfer: true, employeeId })
                .then(() => {
                    this.$Progress.finish()
                    this.request = 'success'
                    setTimeout(() => {
                        this.request = ''
                    }, 500)
                })
                .catch(() => {
                    this.$Progress.finish()
                })
        },
        setEmployeeAvatar(data, type) {
            store.commit('setEmployeeAvatar', {
                data,
                type,
            })
        },
        updateCompaniesEmployeeAvatar(companyId, employeeId, data) {
            store.dispatch('updateCompaniesEmployeeAvatar', {
                companyId,
                employeeId,
                data,
            })
        },
        setCompanyAvatar(data) {
            store.commit('setCompanyAvatar', {
                data,
            })
        },
        updateCompanyAvatar(companyId, data) {
            store.dispatch('updateCompanyAvatar', {
                companyId,
                data,
            })
        },
        toggleShowModalAdd() {
            this.setCLient({
                id: '1b72d449-a990-428e-a747-14945f557311',
                first_name: 'Ilya',
                last_name: 'Makarov',
                email: 'jevon11112121@rowe.com',
                phone: '+380964517343',
                payment_type: 'cash',
                big_image: null,
                small_image: null,
                type: null,
                created_at: '2020-12-09T10:52:20.000000Z',
                addresses: [
                    {
                        id: 'b53bd22c-16c6-48e4-af72-bdee466ed91f',
                        postcode: '1120',
                        country: 'Austria',
                        city: 'Vienna',
                        street: 'Arndtstra\u00dfe',
                        house: '77',
                        entrance: null,
                        apartment: '1',
                        description: null,
                        longitude: '16.3317874',
                        latitude: '48.1818151',
                        default: false,
                    },
                ],
                is_read: true,
                deletion_tag: false,
            })
            this.setClientModalType('add')
            this.setClientModal(true)
        },
        // async addNewRequest(data) {
        //   this.$Progress.start();
        //   await this.addApplication(data);

        //   this.toggleShowRequestModalAdd();
        //   this.$Progress.finish();
        // },
        async filter() {
            await store.dispatch('getClientsData', {
                params: this.params,
                word: this.$store.state.clients.search,
            })
        },
    },
    async created() {
        await store.dispatch('getClientsData', {})
        this.isLoad = true
    },
    beforeDestroy() {
        this.isLoad = false
        this.$store.state.clients.search = ''
        this.clearClientParams()
    },
}
</script>
<style lang="scss" scoped>
// @import "src/assets/sass/main";
// .masters {
//   width: 100%;
//   height: 100%;
//   padding: 60px;
//   box-sizing: border-box;

//   h2 {
//     margin: 0;
//     font-size: 32px;
//     color: #4d4d4d;
//   }

//   &__controls {
//     margin-bottom: 13px;
//     display: flex;
//     justify-content: space-between;
//     align-items: flex-end;
//   }
//   & .select {
//     max-width: 240px;
//   }
// }
</style>
